import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { erpApi } from '@/shared/axios/erp-api';
import { urlBackend } from '@/shared/constants';
import { TIPOCOMPRAS,ITypeComprasPagingRes, UseMutationsParams, AlertSeverityEnum } from '@/shared/interfaces';
import { useUiStore } from '@/store/ui';
import { getUrlParamsFetch , handleAxiosError} from '@/shared';
const { get, post, put } = erpApi();

///* tanSctack query
export const useFetchTypeCompras = ({
    page = 1,
    page_size = 10,
    nombre = '',
  }: GetTypeComprasParams) => {
    return useQuery({
      queryKey: ['tipo-compras', page, nombre, page_size],
      queryFn: async () => {
        return getTypeCompras({ page, nombre, page_size });
      },
    });
  };
  export const useGetTypeCompra = (id: string) => {
    return useQuery({
      queryKey: ['tipo-compras', id],
      queryFn: async () => {
        return getTypeCompra(id);
      },
    });
  };
  export const useCreateTypeCompras = ({
    navigate,
  
    enableRedirect = true,
    returnUrl,
  
    returnErrorUrl,
    enableErrorRedirect = false,
    customMessageErrorAlert,
  
    enableSuccessAlert = true,
    customSuccessMessage,
  }: UseMutationsParams) => {
    const queryClient = useQueryClient();
    const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
    const setAlert = useUiStore.getState().setAlert;
  
    return useMutation({
      mutationFn: createTypeCompras,
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['tipo-compras'] });
  
        enableRedirect && navigate && returnUrl && navigate(returnUrl);
  
        enableSuccessAlert &&
          setAlert &&
          setAlert(
            true,
            customSuccessMessage ?? 'Tipo de compras creada correctamente',
            AlertSeverityEnum.success
          );
      },
      onError: error => {
        enableErrorRedirect &&
          navigate &&
          returnUrl &&
          navigate(returnErrorUrl ?? (returnUrl || ''));
  
        handleAxiosError(error, customMessageErrorAlert);
      },
      onSettled: () => {
        setIsGlobalLoading(false);
      },
    });
  };
  
  export const useUpdateTypeCompras = ({
    navigate,
  
    enableRedirect = true,
    returnUrl,
  
    returnErrorUrl,
    enableErrorRedirect = false,
    customMessageErrorAlert,
  
    enableSuccessAlert = true,
    customSuccessMessage,
  }: UseMutationsParams) => {
    const queryClient = useQueryClient();
    const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
    const setAlert = useUiStore.getState().setAlert;
  
    return useMutation({
      mutationFn: updateTypeCompras,
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['tipo-compras'] });
        enableRedirect && navigate && returnUrl && navigate(returnUrl);
  
        enableSuccessAlert &&
          setAlert &&
          setAlert(
            true,
            customSuccessMessage ?? 'Tipo compras actualizada correctamente',
            AlertSeverityEnum.success
          );
      },
      onError: error => {
        enableErrorRedirect &&
          navigate &&
          returnUrl &&
          navigate(returnErrorUrl ?? (returnUrl || ''));
  
        handleAxiosError(error, customMessageErrorAlert);
      },
      onSettled: () => {
        setIsGlobalLoading(false);
      },
    });
  };
  
///* axios
export type GetTypeComprasParams = {
    page?: number;
    page_size?: number;
    nombre?: string;
  };
  export type CreateTypeComprasParams = Omit<TIPOCOMPRAS, 'id_tipo_compra'>;
  export type UpdateTypeComprasParams = {
    id: string;
    data: CreateTypeComprasParams;
  };
  export const getTypeCompras = async (params?: GetTypeComprasParams) => {
    const queryParams = getUrlParamsFetch({ ...params });  
    return get<ITypeComprasPagingRes>(
      `${urlBackend}api/v1/tipos-compras/?${queryParams}`,
      true
    );
  };
  export const getTypeCompra = async (id: string) => {
    try{
    return await get<TIPOCOMPRAS>(`${urlBackend}api/tipos-compras/${id}/`, true);
    }
    catch(error){
      return handleAxiosError(error);
    }
  };
export const createTypeCompras = async (data: CreateTypeComprasParams) => {
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
  setIsGlobalLoading(true);

  return post<TIPOCOMPRAS>(`${urlBackend}api/v1/tipos-compras/`, data, true);
};

export const updateTypeCompras = async ({id ,data}: UpdateTypeComprasParams) => {
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
  setIsGlobalLoading(true);

  return put<TIPOCOMPRAS>(`${urlBackend}api/v1/tipos-compras/${id}/`, data, true);
    }

